import railsAxios from '../../lib/railsAxios';

const addAbsentKeys = (data) => {
  const defaultValues = {
    bank_name:                   null,
    income:                      null,
    last_loan_application_state: null,
    loan_application_type:       null,
    pay_date_ordinal:            null,
  };
  return {
    ...defaultValues,
    ...data,
  };
};

const updateDataAnalyticsLayer = async (dataLayer) => {
  if (dataLayer) {
    analyticsDataLayer = addAbsentKeys(dataLayer);
  } else {
    try {
      const response = await railsAxios.get('/api/analytics-data-layer');
      analyticsDataLayer = addAbsentKeys(response.data.data);

      if (typeof satelliteTrackPendingEvents !== 'undefined') {
        // eslint-disable-next-line no-undef
        satelliteTrackPendingEvents();
      }
    } catch (error) {
      // Data from call not required
      // No need to flash error message here
      // Logging happens in railsAxios

    }
  }
};

export default updateDataAnalyticsLayer;
